var map = {
	"./5d-4be64165.png": 3972,
	"./BIGOLIFE1.png": 1158,
	"./KENO.b46b0ad4.png": 6822,
	"./KENO.eadd2dc4.png": 9548,
	"./SICBO.30ef5ab9.png": 8180,
	"./SICBO.b8afca93.png": 7348,
	"./TrxWingo-7fc426b2.png": 1357,
	"./WinGo-749c393c.png": 9801,
	"./YNCP.5f7d592e.png": 763,
	"./ae.png": 1417,
	"./all.a4d78610.png": 3502,
	"./award_bigo.png": 6301,
	"./banca.png": 617,
	"./bbin.png": 8255,
	"./box-banking.png": 4146,
	"./box-banking2.png": 5435,
	"./boxbg.png": 5194,
	"./footer-bg.png": 6500,
	"./game_mini-d03d72bd.png": 7356,
	"./hotLottery.0a733060.png": 1575,
	"./icon-xs.png": 8601,
	"./icon_bxh.png": 616,
	"./icon_credit.png": 614,
	"./icon_gift.png": 5958,
	"./iconbigolife.png": 6484,
	"./invitation_bg.png": 8256,
	"./invite.png": 271,
	"./k3-3fb4362a.png": 9662,
	"./lobby.e990b38c.png": 7071,
	"./login-bg.png": 7156,
	"./logo-k333.685bfbc8.png": 7249,
	"./logo-vietlott.png": 5076,
	"./lottery-81925723.png": 1187,
	"./lottery-e8asj.png": 5576,
	"./mien-bac.png": 5573,
	"./mien-nam.png": 6280,
	"./mien-trung.png": 2810,
	"./n1.png": 3209,
	"./n2.png": 8949,
	"./n3.png": 2601,
	"./n4.png": 8075,
	"./n5.png": 137,
	"./n6.png": 6238,
	"./num1.png": 4839,
	"./num2.png": 7387,
	"./num3.png": 4501,
	"./num4.png": 3344,
	"./num5.png": 1170,
	"./num6.png": 3099,
	"./quayhu.png": 5765,
	"./taikhoandautu.png": 9707,
	"./taixiu1.png": 9329,
	"./tienlai.png": 7616,
	"./v1.png": 187,
	"./v10.png": 4418,
	"./v2.png": 4463,
	"./v3.png": 2959,
	"./v4.png": 9633,
	"./v5.png": 6383,
	"./v6.png": 5308,
	"./v7.png": 2450,
	"./v8.png": 4590,
	"./v9.png": 2695,
	"./vietllot.png": 2506,
	"./vietlott3.png": 8276,
	"./xocdia.png": 2240,
	"./xocdia2.png": 9022,
	"./xs3mien/angiang.png": 6879,
	"./xs3mien/baclieu.png": 9013,
	"./xs3mien/bentre.png": 6756,
	"./xs3mien/binhdinh.png": 7965,
	"./xs3mien/binhduong.png": 4842,
	"./xs3mien/binhphuoc.png": 2963,
	"./xs3mien/binhthuan.png": 293,
	"./xs3mien/camau.png": 4555,
	"./xs3mien/cantho.png": 2383,
	"./xs3mien/daklak.png": 2266,
	"./xs3mien/daknong.png": 1589,
	"./xs3mien/dalat.png": 1008,
	"./xs3mien/danang.png": 7231,
	"./xs3mien/dongnai.png": 9460,
	"./xs3mien/dongthap.png": 4506,
	"./xs3mien/gialai.png": 4524,
	"./xs3mien/haugiang.png": 774,
	"./xs3mien/hue.png": 3219,
	"./xs3mien/khanhhoa.png": 17,
	"./xs3mien/kiengiang.png": 5065,
	"./xs3mien/komtum.png": 8785,
	"./xs3mien/longan.png": 879,
	"./xs3mien/mienbac.png": 4360,
	"./xs3mien/ninhthuan.png": 123,
	"./xs3mien/phuyen.png": 1228,
	"./xs3mien/quangbinh.png": 4675,
	"./xs3mien/quangnam.png": 4133,
	"./xs3mien/quangngai.png": 6697,
	"./xs3mien/quangtri.png": 2115,
	"./xs3mien/soctrang.png": 7753,
	"./xs3mien/tayninh.png": 5430,
	"./xs3mien/tiengiang.png": 9709,
	"./xs3mien/tphcm.png": 2199,
	"./xs3mien/travinh.png": 2835,
	"./xs3mien/vinhlong.png": 7680,
	"./xs3mien/vungtau.png": 8984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;